const permissionsList = [
  {
    title: 'UserAdmin page',
    dataIndex: 'UserAdminPage',
    key: 'UserAdminPage',
    isPage: true,
  },
  {
    title: 'Digitize page',
    dataIndex: 'DigitizePage',
    key: 'DigitizePage',
    isPage: true,
  },
  {
    title: 'Enhance page',
    dataIndex: 'EnhancePage',
    key: 'EnhancePage',
    isPage: true,
  },
  {
    title: 'Create page',
    dataIndex: 'CreatePage',
    key: 'CreatePage',
    isPage: true,
  },
  {
    title: 'Collections page',
    dataIndex: 'CollectionsPage',
    key: 'CollectionsPage',
    isPage: true,
  },
  {
    title: 'GiftCard page',
    dataIndex: 'GiftCardPage',
    key: 'GiftCardPage',
    isPage: true,
  },
  {
    title: 'Deliveries page',
    dataIndex: 'DeliveriesPage',
    key: 'DeliveriesPage',
    isPage: true,
  },
  {
    title: 'Blog page',
    dataIndex: 'BlogPage',
    key: 'BlogPage',
    isPage: true,
  },
  {
    title: 'ZipCodes page',
    dataIndex: 'ZipCodesPage',
    key: 'ZipCodesPage',
    isPage: true,
  },
  {
    title: 'Marketing page',
    dataIndex: 'MarketingPage',
    key: 'MarketingPage',
    isPage: true,
  },
  {
    title: 'Promotions page',
    dataIndex: 'PromotionsPage',
    key: 'PromotionsPage',
    isPage: true,
  },
  {
    title: 'Settings page',
    dataIndex: 'SettingsPage',
    key: 'SettingsPage',
    isPage: true,
  },
  {
    title: 'Rush page',
    dataIndex: 'RushPage',
    key: 'RushPage',
    isPage: true,
  },
  {
    title: 'HelpCenter page',
    dataIndex: 'HelpCenterPage',
    key: 'HelpCenterPage',
    isPage: true,
  },
  {
    title: 'Permissions page',
    dataIndex: 'PermissionsPage',
    key: 'PermissionsPage',
    isPage: true,
  },
  {
    title: 'Projects page',
    dataIndex: 'ProjectsPage',
    key: 'ProjectsPage',
    isPage: true,
  },
  {
    title: 'Tasks page',
    dataIndex: 'TasksPage',
    key: 'TasksPage',
    isPage: true,
  },
  {
    title: 'SubTasks page',
    dataIndex: 'SubTasksPage',
    key: 'SubTasksPage',
    isPage: true,
  },
  {
    title: 'Clients page',
    dataIndex: 'ClientsPage',
    key: 'ClientsPage',
    isPage: true,
  },
  {
    title: 'Tickets page',
    dataIndex: 'TicketsPage',
    key: 'TicketsPage',
    isPage: true,
  },
  {
    title: 'Reports page',
    dataIndex: 'ReportsPage',
    key: 'ReportsPage',
    isPage: true,
  },
  {
    title: 'Admin page',
    dataIndex: 'AdminPage',
    key: 'AdminPage',
    isPage: true,
  },
  {
    title: 'Orders page',
    dataIndex: 'OrdersPage',
    key: 'OrdersPage',
    isPage: true,
  },
  {
    title: 'Cart page',
    dataIndex: 'CartPage',
    key: 'CartPage',
    isPage: true,
  },
  {
    title: 'Leads Page',
    dataIndex: 'EvaluationPage',
    key: 'EvaluationPage',
    isPage: true,
  },
  {
    title: 'Subscriptions Page',
    dataIndex: 'SubscriptionsPage',
    key: 'SubscriptionsPage',
    isPage: true,
  },
  {
    title: 'Sms Page',
    dataIndex: 'SmsPage',
    key: 'SmsPage',
    isPage: true,
  },
  {
    title: 'Refunds',
    dataIndex: 'refunds',
    key: 'refunds',
    isPage: false,
  },
  {
    title: 'Change order items',
    dataIndex: 'order-items:put',
    key: 'order-items:put',
    isPage: false,
  },
  {
    title: 'Add subscription to account',
    dataIndex: 'user-subscription:post',
    key: 'user-subscription:post',
    isPage: false,
  },
  {
    title: 'Change subscription in account',
    dataIndex: 'user-subscription:put',
    key: 'user-subscription:put',
    isPage: false,
  },
  {
    title: 'Tasks change',
    dataIndex: 'tasks:put',
    key: 'tasks:put',
    isPage: false,
  },
  {
    title: 'Subtasks change',
    dataIndex: 'subtasks:put',
    key: 'subtasks:put',
    isPage: false,
  },
  {
    title: 'Contact change',
    dataIndex: 'contact:put',
    key: 'contact:put',
    isPage: false,
  },
  {
    title: 'Change price',
    dataIndex: 'price',
    key: 'price',
    isPage: false,
  },
  {
    title: 'See payment info',
    dataIndex: 'payment-methods:get',
    key: 'payment-methods:get',
    isPage: false,
  },
  {
    title: 'Discounts',
    dataIndex: 'additionalDiscount',
    key: 'additionalDiscount',
    isPage: false,
  },
  {
    title: 'Quantity',
    dataIndex: 'quantity',
    key: 'quantity',
    isPage: false,
  },
  {
    title: 'View history',
    dataIndex: 'history',
    key: 'history',
    isPage: false,
  },
  {
    title: 'Add to order',
    dataIndex: 'order:put',
    key: 'order:put',
    isPage: false,
  },
  {
    title: 'Delete orders',
    dataIndex: 'order:delete',
    key: 'order:delete',
    isPage: false,
  },
  {
    title: 'Delete task',
    dataIndex: 'deleteTask',
    key: 'deleteTask',
    isPage: false,
  },
  {
    title: 'Delete subtask',
    dataIndex: 'deleteSubtask',
    key: 'deleteSubtask',
    isPage: false,
  },
  {
    title: 'Change Placed by',
    dataIndex: 'fresh-sales:put',
    key: 'fresh-sales:put',
    isPage: false,
    resizable: true,
  },
];

const columns = () => ([
  {
    title: 'Permissions',
    dataIndex: 'title',
    key: 'title',
    width: 250,
  },
  {
    title: 'Admin',
    dataIndex: 'admin',
    key: 'admin',
    width: 80,
  },
  {
    title: 'Artist Lead',
    dataIndex: 'artist_lead',
    key: 'artist_lead',
    width: 80,
  },
  {
    title: 'Artist',
    dataIndex: 'artist',
    key: 'artist',
    width: 80,
  },
  {
    title: 'Manager',
    dataIndex: 'manager',
    key: 'manager',
    width: 80,
  },
  {
    title: 'Pm user',
    dataIndex: 'pm_user',
    key: 'pm_user',
    width: 80,
  },
  {
    title: 'Project manager',
    dataIndex: 'project_manager',
    key: 'project_manager',
    width: 100,
  },
  {
    title: 'Sales',
    dataIndex: 'sales',
    key: 'sales',
    width: 80,
  },
  {
    title: 'Sales manager',
    dataIndex: 'sales_manager',
    key: 'sales_manager',
    width: 100,
  },
  {
    title: 'Social',
    dataIndex: 'social',
    key: 'social',
    width: 80,
  },
  {
    title: 'Client User',
    dataIndex: 'user',
    key: 'user',
    width: 100,
  },
]);
export {
  columns,
  permissionsList,
};
